// src/context/CourseContext.js
import React, { createContext, useState, useEffect } from 'react';
import ICONS from '../config/icon';
import { useAuth } from '../auth/AuthContext';

// Kontext erstellen
export const CourseContext = createContext();

// Provider-Komponente
export const CourseProvider = ({ children }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userId } = useAuth();

  useEffect(() => {
    if (!userId) {
      console.warn("⚠️ Kein Benutzer angemeldet, Kursdaten werden nicht geladen.");
      setCourses([]);
      setLoading(false);
      return;
    }

    const fetchCourses = async () => {
      try {
        const res = await fetch(
          `https://www.denisbitter.de/stage01/api/get_user_courses.php?userId=${userId}`
        );
        const data = await res.json();

        if (!data.success || !Array.isArray(data.data)) {
          throw new Error(data.message || "Unerwartete API-Antwort");
        }

        // Hier das Mapping anpassen, damit wir im Frontend
        // mit einheitlichen Feldnamen arbeiten:
        const coursesWithIcons = data.data.map((course) => ({
          // Backend liefert z. B. course.course_id, course.course_slug usw.
          id: course.course_id,
          slug: course.course_slug,
          title: course.course_title,
          description: course.course_description,
          iconName: course.course_icon,           // roher Icon-Key aus der DB
          category: course.course_category,
          startDate: course.course_startDate,
          customDate: course.registration_custom_date,
          pdfPath: course.registration_pdf_path,   // wenn du diese Information brauchst
          firstName: course.registrant_first_name, // registrierender Vorname
          lastName: course.registrant_last_name,   // registrierender Nachname
          registrationDate: course.registration_date,
          // Hier weisen wir das Icon-Objekt bzw. die React-Komponente aus ICONS zu:
          Icon: ICONS[course.course_icon] || ICONS.default,
        }));

        setCourses(coursesWithIcons);
      } catch (err) {
        console.error("❌ Fehler beim Laden der Kurse:", err);
        setError(err.message || "Unbekannter Fehler");
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [userId]);

  return (
    <CourseContext.Provider value={{ courses, loading, error }}>
      {children}
    </CourseContext.Provider>
  );
};
